import {
    Container,
    ContainerDescription,
    ContentDescriptionProblem,
    ContentLineClamp,
    TextDescriptionProblem,
    ContentProtocol,
    TextProtocol,
    ContentExportation,
    ContentButtonExportation,
    Separator,
    ContentDataTicket,
    ContentClientData,
    ContentEdit,
    TextClient,
    IconEdit,
    ContentSector,
    ContentProgress,
    TextExportation,
    ContainerSuccessExport,
    ContentExportDetails,
    ContentDeleteExport,
    ContainerButtonDeleteExport, TextDownloadExport,
} from "./styled";
import {Tooltip} from "antd";
import {observer} from "mobx-react";
import React, {useContext} from "react";
import {useBetween} from "use-between";
import {useModalViewTickets} from "@dropDesk/presentation/components/chat_view/modals/visible_modal_view_ticket";
import AvatarImage from "@dropDesk/presentation/components/avatar";
import {TicketEntity} from "@dropDesk/domain/entities/ticket/ticket.entity";
import {useInjection} from "inversify-react";
import {AppController} from "@dropDesk/presentation/app/app.controller";
import {ICONS_DROPDESK} from "@dropDesk/storage/icons/icons.d";
import {MenuCollapsedContext} from "@dropDesk/presentation/routes/private_route";
import {Progress} from "@dropDesk/presentation/components/loadings/progress_bar";
import {ButtonAction, ContentButton} from "@dropDesk/presentation/components/chat_view/header_action_buttons/styled";
import {Brightness} from "@dropDesk/domain/entities/theme/colors.entity";
import DropDeskIcon from "@dropDesk/storage/icons";
import {formatDateToDDMMYYYY} from "@dropDesk/utils/helpers/date_helper";
import {ExportTicketStatusEntity} from "@dropDesk/domain/entities/ticket/export_ticket_status.entity";
import ClipLoading from "@dropDesk/presentation/components/loadings/loading_clip";

const HeaderViewInformation = observer(
    ({
         ticket,
         canChange,
         canChangeClient,
         alertPulseAnimation,
         loading,
         widthContainerListChats,
         onClickDownloadExportTicket,
         onClickDeleteExport,
         exportTicketStatus,
         loadingGetCurrentStateExport,
         cancelExport
     }: {
        ticket: TicketEntity
        canChange: boolean,
        canChangeClient: boolean,
        loading: boolean,
        alertPulseAnimation?: boolean,
        widthContainerListChats?: number
        onClickDownloadExportTicket: (exportStatus: ExportTicketStatusEntity) => void
        onClickDeleteExport: () => void
        exportTicketStatus: ExportTicketStatusEntity | null
        loadingGetCurrentStateExport: boolean
        cancelExport: (id: string) => Promise<void>
    }) => {
        const collapsed = useContext(MenuCollapsedContext);
        const appController = useInjection(AppController);
        const colors = appController.theme.colorScheme;
        const widthContainerProfile = 61;
        const widthButtonExport = 300;
        const widthHeader = ((widthContainerListChats ?? 0) + (collapsed ? 80 : 250) + widthContainerProfile + 100 + widthButtonExport);
        const {
            setVisibleModalCreateClient,
            setVisibleModalChangeProblemDescription,
            setVisibleModalExportHTML
        } = useBetween(useModalViewTickets);

        return (
            <Container bordercolor={colors.delicateBackground} background={"transparent"}>

                <ContainerDescription>
                    <ContentDataTicket>
                        <AvatarImage
                            useCursorPointer={ticket.userClient?.urlImageProfile ? true : false}
                            title={ticket.userClient?.name ?? ''}
                            size={45}
                            url={ticket.userClient?.urlImageProfile}
                            round={true}
                            hasPreviewImage={true}
                            letterSize={20}
                            isBackgroundChat={true}
                            alertPulseAnimation={alertPulseAnimation}
                            badgeOrigin={ticket.getOriginBadge}
                        />
                        <ContentDescriptionProblem>
                            <ContentClientData>
                                <ContentProtocol>
                                    <Tooltip title={"Protocolo do atendimento"} placement="topLeft">
                                        <TextProtocol color={colors.text}>#{ticket.number}</TextProtocol>
                                    </Tooltip>
                                </ContentProtocol>

                                <Separator>
                                    <TextProtocol color={colors.text}> - </TextProtocol>
                                </Separator>
                                <ContentEdit color={colors.text} canChange={canChangeClient} onClick={() => {
                                    if (canChangeClient) {
                                        setVisibleModalCreateClient(true);
                                    }
                                }}>
                                    <ContentLineClamp width={widthHeader + 50}>
                                        <Tooltip title={"Nome do contato"} placement="topLeft">
                                            <TextClient
                                                color={colors.text}>{ticket.userClient?.name ?? ''}</TextClient>
                                        </Tooltip>

                                        {ticket.userClient?.telephone &&

                                            <Tooltip title={"Telefone do contato"} placement="topLeft">
                                                <TextClient
                                                    color={colors.text}>&nbsp;&nbsp;{ticket.userClient?.telephone ?? ''}</TextClient>
                                            </Tooltip>
                                        }
                                    </ContentLineClamp>

                                    <IconEdit
                                        size={13}
                                        className={`icon-${ICONS_DROPDESK.edit}`}
                                        color={colors.text}
                                    />
                                </ContentEdit>
                            </ContentClientData>

                            <div style={{display: 'flex', flexDirection: 'row'}}>
                                <ContentEdit color={colors.text} canChange={canChange} onClick={() => {
                                    if (canChange) {
                                        setVisibleModalChangeProblemDescription(true);
                                    }
                                }}>
                                    <ContentLineClamp width={widthHeader} toShare={!!ticket.sector}>
                                        <Tooltip placement="topLeft" title={"Descrição do problema"}>
                                            <TextDescriptionProblem color={colors.text}>
                                                {ticket.realDescription(appController.user?.company.configurations.ticket.useProblemStatic ?? false, loading)}
                                            </TextDescriptionProblem>
                                        </Tooltip>
                                    </ContentLineClamp>
                                    <IconEdit
                                        size={13}
                                        className={`icon-${ICONS_DROPDESK.edit}`}
                                        color={colors.text}
                                    />
                                </ContentEdit>

                                {ticket.sector && <ContentSector color={colors.text}>
                                    <ContentLineClamp width={widthHeader} toShare={!!ticket.sector}>
                                        <Tooltip placement="topLeft" title={"Setor"}>
                                            <TextDescriptionProblem color={colors.text}>
                                                &nbsp;&nbsp;|&nbsp;&nbsp;{ticket.sector?.realName(appController.user!) ?? ''}
                                            </TextDescriptionProblem>
                                        </Tooltip>
                                    </ContentLineClamp>
                                </ContentSector>}
                            </div>
                        </ContentDescriptionProblem>
                    </ContentDataTicket>


                </ContainerDescription>

                <ContentExportation>
                    {!loadingGetCurrentStateExport && <>

                        {(!exportTicketStatus || exportTicketStatus.error || exportTicketStatus.canceled) &&
                            <ContentButtonExportation>

                                <ContentButton disable={false}>
                                    <ButtonAction
                                        border={colors.border}
                                        accent={colors.accent}
                                        onClick={() => setVisibleModalExportHTML(true)}
                                        isDarkTheme={colors.brightness === Brightness.dark}
                                        disabled={false}
                                        width={110}
                                        color={colors.text}
                                        background={colors.backgroundInput}
                                    >
                                        <DropDeskIcon
                                            icon={ICONS_DROPDESK.documentOutline}
                                            size={16}
                                        />
                                        Exportar
                                    </ButtonAction>
                                </ContentButton>
                            </ContentButtonExportation>
                        }

                        {exportTicketStatus && exportTicketStatus.inProgress &&
                            <ContentProgress>
                                <TextExportation color={colors.text}>Exportando atendimento</TextExportation>
                                <Progress
                                    progress={parseFloat((exportTicketStatus.progress * 100).toFixed(1))}
                                    width={150}
                                    type={'line'}
                                    fontSize={12}
                                />
                                <DropDeskIcon
                                    icon={ICONS_DROPDESK.cancel}
                                    color={colors.textError}
                                    onClick={() => cancelExport(ticket.id)}
                                    size={15}
                                    style={{cursor: 'pointer', marginBottom: -3, marginLeft: -3}}
                                    useDarkenInHover={true}
                                />
                            </ContentProgress>
                        }

                        {exportTicketStatus && exportTicketStatus.done &&
                            <ContainerSuccessExport bordercolor={colors.border}>
                                <ContentExportDetails>
                                    <TextExportation color={colors.text}>
                                        Última
                                        exportação: {formatDateToDDMMYYYY(new Date(exportTicketStatus.createdAt))}
                                    </TextExportation>
                                    <TextDownloadExport onClick={() => {
                                        onClickDownloadExportTicket(exportTicketStatus);
                                    }} color={colors.textLink}>
                                        Baixar exportação
                                    </TextDownloadExport>

                                </ContentExportDetails>
                                <ContentDeleteExport>
                                    <Tooltip title={'Excluir exportação'} placement={'left'}>
                                        <ContainerButtonDeleteExport
                                            accent={colors.accent}
                                            background={colors.buttonOnBackground}
                                            onClick={() => {
                                                onClickDeleteExport();
                                            }}
                                            bordercolor={colors.border}
                                        >
                                            <DropDeskIcon
                                                icon={ICONS_DROPDESK.delete}
                                                color={colors.textError}
                                                size={14}
                                            />
                                        </ContainerButtonDeleteExport>
                                    </Tooltip>
                                </ContentDeleteExport>
                            </ContainerSuccessExport>
                        }
                    </>}
                    {loadingGetCurrentStateExport &&
                        <ClipLoading color={colors.accent} size={12}/>
                    }
                </ContentExportation>
            </Container>
        );
    });
export default HeaderViewInformation;
